import { render } from "./OcrUpload.vue?vue&type=template&id=a6bbd200&scoped=true"
import script from "./OcrUpload.vue?vue&type=script&lang=js"
export * from "./OcrUpload.vue?vue&type=script&lang=js"

import "./OcrUpload.vue?vue&type=style&index=0&id=a6bbd200&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6bbd200"]])

export default __exports__